import { NgModule } from '@angular/core';
import { EmptyTextPlaceholderPipe } from './empty-text-placeholder/empty-text-placeholder.pipe';
import { FormatQuantityPipe } from './format-quantity/format-quantity.pipe';
import { ShortSsccCodePipe } from './short-sscc-code/short-sscc-code.pipe';
import { UtcToLocalDatePipe } from './utc-to-local-date/utc-to-local-date.pipe';
import { SsccPipe } from './sscc/sscc.pipe';
import { FormatUnitIdPipe } from './format-unit-id/format-unit-id.pipe';
import { ReplaceLineBreaksPipe } from './replace-line-breaks/replace-line-breaks.pipe';

@NgModule({
  declarations: [
    FormatQuantityPipe,
    FormatUnitIdPipe,
    EmptyTextPlaceholderPipe,
    ReplaceLineBreaksPipe,
    ShortSsccCodePipe,
    UtcToLocalDatePipe,
    SsccPipe],
  exports: [
    FormatQuantityPipe,
    FormatUnitIdPipe,
    EmptyTextPlaceholderPipe,
    ReplaceLineBreaksPipe,
    ShortSsccCodePipe,
    UtcToLocalDatePipe,
    SsccPipe]
})
export class PipesModule {}
